// import Layout from '../components/layouts/site/index.vue';
import Profile from '../components/pages/user-profile/profile.vue';
import Search from '../components/pages/search.vue';
import Groups from '../components/usersManagement/group/index.vue';
import Permissions from '../components/permissionsManagement/index.vue';
import Alarms from '../components/pages/alarms/index.vue';
import Alerts from '../components/pages/alerts/index.vue';

// Routes
const routes = [
    {
        path: '/groups',
        name: 'group-list',
        component: Groups
    },
    {
        path: '/permission',
        name: 'permission',
        component: Permissions
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile
    },
    {
        path: '/reset-password/:userUid?/:userEmail?',
        name: 'reset-password',
        component: Profile
    },
    {
        path: '/set-password/:passwordChangeToken?/:userEmail?',
        name: 'set-password',
        component: Profile
    },
    {
        path: '/search',
        name: 'search',
        component: Search
    },
    {
        path: '/alarms',
        name: 'alarms',
        component: Alarms
    },
    {
        path: '/alerts',
        name: 'alerts',
        component: Alerts
    },
];

export default routes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/router/routes.js
// module id = null
// module chunks = 